import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookingModal } from '../components/BookingModal';
import { RSVPModal } from '../components/RSVPModal';
export function LandingPage() {
  const navigate = useNavigate();
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isRSVPModalOpen, setIsRSVPModalOpen] = useState(false);
  return <div className="min-h-screen bg-gradient-to-br from-navy via-navy-light to-navy flex flex-col" data-id="element-749">
      {/* Logo - Center Top */}
      <div className="pt-3 md:pt-4 pb-1 md:pb-2 flex justify-center" data-id="element-750">
        <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-16 md:h-20 lg:h-24" data-id="element-751" />
      </div>

      {/* Main Content - Centered */}
      <div className="flex-1 flex items-center justify-center px-4 py-2 md:py-3" data-id="element-752">
        <div className="max-w-4xl w-full text-center" data-id="element-753">
          {/* Heading */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-8 md:mb-12" data-id="element-754">
            Calculate Your Recruiting ROI
          </h1>

          {/* Two Calculator Options */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16 md:mb-24" data-id="element-755">
            {/* Summer Program Option */}
            <div className="bg-white/5 backdrop-blur-sm border-2 border-white/20 rounded-xl p-6 md:p-8 hover:bg-white/10 transition-all" data-id="element-756">
              <div className="mb-4" data-id="element-757">
                <div className="inline-block px-3 py-1 bg-green-500/20 border border-green-400/30 rounded-full text-green-300 text-xs font-semibold mb-3" data-id="element-758">
                  SEASONAL
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-759">
                  Summer Program
                </h2>
                <p className="text-sm md:text-base text-blue-200" data-id="element-760">
                  For teams that operate during peak season (typically 4-6
                  months)
                </p>
              </div>
              <button onClick={() => navigate('/calculator-summer')} className="group w-full inline-flex items-center justify-center gap-2 md:gap-3 px-6 md:px-8 py-4 md:py-5 bg-green-500 hover:bg-green-600 text-white font-bold text-base md:text-lg rounded-lg transition-all shadow-2xl hover:shadow-green-500/50 hover:scale-105 active:scale-100" data-id="element-761">
                <span data-id="element-762">Calculate Summer ROI</span>
                <svg className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-763">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-764" />
                </svg>
              </button>
            </div>

            {/* Year-Round Program Option */}
            <div className="bg-white/5 backdrop-blur-sm border-2 border-white/20 rounded-xl p-6 md:p-8 hover:bg-white/10 transition-all" data-id="element-765">
              <div className="mb-4" data-id="element-766">
                <div className="inline-block px-3 py-1 bg-amber/20 border border-amber/30 rounded-full text-amber text-xs font-semibold mb-3" data-id="element-767">
                  YEAR-ROUND
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-768">
                  Year-Round Program
                </h2>
                <p className="text-sm md:text-base text-blue-200" data-id="element-769">
                  For teams that recruit and sell consistently throughout the
                  year
                </p>
              </div>
              <button onClick={() => navigate('/calculator')} className="group w-full inline-flex items-center justify-center gap-2 md:gap-3 px-6 md:px-8 py-4 md:py-5 bg-amber hover:bg-amber-dark text-navy font-bold text-base md:text-lg rounded-lg transition-all shadow-2xl hover:shadow-amber/50 hover:scale-105 active:scale-100" data-id="element-770">
                <span data-id="element-771">Calculate Year-Round ROI</span>
                <svg className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-772">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-773" />
                </svg>
              </button>
            </div>
          </div>

          {/* Strategy Call CTA */}
          <div data-id="element-774">
            <button onClick={() => setIsBookingModalOpen(true)} className="group relative inline-flex items-center gap-2 md:gap-3 px-6 md:px-8 py-4 md:py-5 bg-white/10 hover:bg-white/20 border-2 border-white/30 hover:border-white/50 text-white font-bold text-lg md:text-xl rounded-lg transition-all shadow-xl backdrop-blur-sm hover:scale-105 active:scale-100 mb-4" data-id="element-775">
              <span data-id="element-776">Schedule a Strategy Call</span>
              <svg className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-777">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-778" />
              </svg>
            </button>
            <p className="text-sm md:text-base text-blue-100 max-w-2xl mx-auto" data-id="element-779">
              Book time with a recruiting systems specialist.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-navy border-t-2 border-white/10" data-id="element-780">
        <div className="max-w-7xl mx-auto px-4 py-6 md:py-8" data-id="element-781">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-782">
            <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-8" data-id="element-783" />
            <p className="text-sm md:text-base text-blue-200 font-medium" data-id="element-784">
              Stop Chasing Applicants. Get a Recruiting System.
            </p>
          </div>
        </div>
      </footer>

      {/* Booking Modal */}
      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} data-id="element-785" />

      {/* RSVP Modal */}
      <RSVPModal isOpen={isRSVPModalOpen} onClose={() => setIsRSVPModalOpen(false)} data-id="element-786" />
    </div>;
}